import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { BirthInfo } from "../slices/customer/types/birth-info.ts";
import { Personal } from "../slices/customer/types/personal.ts";
import { BirthRequest, DataCollectionApi } from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export interface SubmitBirthActionArgs {
  birthDay: number;
  birthMonth: number;
  birthYear: number;
  birthCountry: string;
  birthCity: string;
  birthProvince: string;
  nationality: string;
}

export const submitBirthAction = createAsyncThunk<
  BirthInfo | Partial<Pick<Personal, "nationality">>,
  SubmitBirthActionArgs,
  ThunkApi
>("submitBirth", async (birthInfoData, { rejectWithValue }) => {
  try {
    const {
      birthDay,
      birthMonth,
      birthYear,
      birthProvince,
      nationality,
      birthCity,
      birthCountry,
    } = birthInfoData;

    const birthRequest: BirthRequest = {
      birthDate: [
        birthYear,
        birthMonth.toString().padStart(2, "0"),
        birthDay.toString().padStart(2, "0"),
      ].join("-"),
      nationality: (nationality as any)?.value,
      birthProvince: (birthProvince as any)?.value,
      birthCity: (birthCity as any)?.nome,
      birthCountry: (birthCountry as any)?.value,
    };

    await new DataCollectionApi().addBirth(birthRequest);

    return {
      birthDate: {
        birthDay,
        birthMonth,
        birthYear,
      },
      nationality: (nationality as any)?.value,
      birthProvince: (birthProvince as any)?.value,
      birthCity: (birthCity as any)?.nome || birthCity,
      birthCountry: (birthCountry as any)?.value,
    };
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio dati anagrafici",
      description:
        "Non siamo riusciti a salvare i tuoi dati anagrafici.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
